import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button, Typography } from "antd";
import useViewport from "components/UseViewport/UseViewport";
import axios from "axios";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import { LogEntry, NoShow } from "interfaces/events";
import SkeletonInput from "antd/lib/skeleton/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import { StyledTextDiv, StyledTextDivBold } from "./style";

const { Title } = Typography;

const StudentLogCard = () => {
  const { width } = useViewport();
  const breakpoint = 900;

  const history = useHistory();
  const [log, setLog] = useState<LogEntry[]>([]);
  const [loadingEvents, setLoadingEvents] = useState<boolean>(true);
  const [loadingWarnings, setLoadingWarnings] = useState<boolean>(true);
  const [warnings, setWarnings] = useState<NoShow[]>([]);

  const { currentUser } = useLoginContext();

  useEffect(() => {
    if (!currentUser) return;
    axios
      .get<LogEntry[]>(`/events/${currentUser?.id}/log/`)
      .then(response => {
        setLog(response.data);
        setLoadingEvents(false);
      })
      .catch(() => {
        setLoadingEvents(false);
      });
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser) return;
    axios
      .get<NoShow[]>(`/events/student-no-shows/${currentUser?.id}/`)
      .then(response => {
        setWarnings(response.data);
        setLoadingWarnings(false);
      })
      .catch(() => {
        setLoadingWarnings(false);
      });
  }, [currentUser]);

  const handleButtonClick = () => {
    history.push("/student-profile");
  };

  return (
    <>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Card style={{ width: "80%" }}>
          <Row align="middle">
            <Col>
              <Button style={{ width: "3.5rem", height: "3rem", fontSize: "1.5rem" }} onClick={handleButtonClick}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
            </Col>
            <Col>
              <Title style={{ margin: 0, paddingLeft: "1rem" }}> Min logg </Title>
            </Col>
          </Row>
          <br />

          <br />
          <Row
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
            }}
          >
            <Col span={width < breakpoint ? 24 : 12}>
              <StyledTextDivBold>Tidligere arrangementer</StyledTextDivBold>
              <br />
              <StyledTextDiv>
                {loadingEvents ? (
                  <SkeletonInput />
                ) : (
                  log?.length === 0 && "Du har ikke deltatt på tidligere arrangementer"
                )}
                {log?.map(entry => (
                  <Button
                    key={entry.id}
                    onClick={() => history.push(`/events/${entry.event}`)}
                    type="link"
                    style={{ padding: 0 }}
                  >
                    {new Date(entry.event_start).toLocaleDateString("no-NB")} - {entry.event_name}
                    <br />
                  </Button>
                ))}
              </StyledTextDiv>
            </Col>
            <Col span={width < breakpoint ? 24 : 12} style={width < breakpoint ? {} : { textAlign: "right" }}>
              <StyledTextDivBold>Advarsler</StyledTextDivBold>
              <br />
              <StyledTextDiv>
                {loadingWarnings ? <SkeletonInput /> : warnings?.length === 0 && "Du har ingen advarsler"}
                {warnings?.map(warning => (
                  <div key={warning.id}>
                    {new Date(warning.time).toLocaleDateString("no-NB")} - {warning.event_name} (
                    {warning.no_show_type === 0 ? "Ikke deltatt" : "Brudd på retningslinjer"})
                  </div>
                ))}
              </StyledTextDiv>
            </Col>
          </Row>
        </Card>
      </div>
    </>
  );
};

export default StudentLogCard;
